module.exports = __webpack_public_path__ + "img/printing-troubleshooting.ba833a46.svg";